export const env = {
  baseUrl: process.env.REACT_APP_BASE_URL ?? 'https://apihomolog.hmestelar.com.br/admin',
  awsS3Realtor: {
    region: process.env.REACT_APP_AWS_S3_REGION ?? 'us-east-1',
    key: process.env.REACT_APP_AWS_S3_KEY ?? '',
    secret: process.env.REACT_APP_AWS_S3_SECRET ?? '',
    bucket: process.env.REACT_APP_AWS_S3_BUCKET ?? 'realtor-files-hml'
  },
  awsS3EnterpriseFiles: {
    region: process.env.REACT_APP_AWS_S3_REGION ?? 'us-east-1',
    key: process.env.REACT_APP_AWS_S3_KEY ?? '',
    secret: process.env.REACT_APP_AWS_S3_SECRET ?? '',
    bucket: process.env.REACT_APP_AWS_S3_BUCKET ?? 'enterprises-files-hml'
  },
}